import React, {Component} from 'react';
import Moment from 'react-moment';
import './CommentEvent.css';

class CommentEvent extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        data: {
            commentId: 1,
            avatarUrl: 'assets/demo/avatars/5.jpg',
            authorId: 1,
            authorName: 'Оператор NetPallet',
            tenderId: 1,
            tenderNumber: '0001',
            text: 'Советую привезти паллеты без аспергилла, а то мои кореша тебя уроют!',
            timestamp: (new Date()).toString()
        }
    };

    render() {
        const { data, ...state } = this.state;
        return (
            <div className="widget-notifications-item p-a-0">
                <div className="widget-tree-comments-item">
                    <img src={data.avatarUrl} alt={`Аватар пользователя ${data.authorName}`} className="widget-comments-avatar" />
                    <div className="widget-tree-comments-header">
                        <a href="#" title="">{data.authorName}</a> оставил комментарий к тендеру <a href="#" title="">№ {data.tenderNumber}</a>
                    </div>
                    <div className="widget-tree-comments-text">{data.text}</div>
                    <div className="widget-tree-comments-footer">
                        <i><Moment fromNow locale="ru">{data.timestamp}</Moment></i>
                        &nbsp;&nbsp;·&nbsp;&nbsp;
                        <a href="#">Ответить</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default CommentEvent;


// WEBPACK FOOTER //
// ./src/pages/EventsFeed/CommentEvent.js